import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CipcProtocolFieldConfig } from '../../../../shared/models/generated/ziroModels';

@Injectable()
export class CipcProtocolFieldConfigResource {
  private http = inject(HttpClient);

  getProtocolFieldConfig(siteId: number): Observable<CipcProtocolFieldConfig> {
    return this.http.get<CipcProtocolFieldConfig>(`/services/cisco/field-configs/cipc-protocol?siteId=${siteId}`);
  }
}
